import { FC } from 'react';
import { Icon, ValidIcons } from '@kizen/kds/Icon';
import { createPortal } from 'react-dom';

const CircleButton = ({
  id,
  circleColor,
  circleIcon,
  onClick,
  zIndex,
  offset,
}: {
  id: string;
  circleColor: string;
  circleIcon: string;
  onClick: () => void;
  zIndex: number;
  offset: number;
}) => {
  return (
    <div
      key={id}
      id={id}
      className="kds w-[48px] h-[48px] rounded-full flex items-center justify-center bg-[var(--circle-color)] select-none pointer-events-auto"
      style={
        {
          '--circle-color': circleColor || 'var(--color-blue-300)',
          zIndex: zIndex + offset,
        } as any
      }
    >
      <div
        className="flex items-center justify-center cursor-pointer text-[var(--icon-color)] w-[48px] h-[48px]"
        style={{ '--icon-color': 'var(--color-gray-50)' } as any}
        onClick={onClick}
      >
        <Icon icon={`custom-${circleIcon}` as ValidIcons} color="gray-50" />
      </div>
    </div>
  );
};

export const CirclePortal: FC<{
  id: string;
  hidden?: boolean;
  triggerElement: string;
  circleColor: string;
  circleIcon: string;
  onClick: () => void;
  zIndex: number;
  offset: number;
  side: 'left' | 'right';
}> = ({
  id,
  hidden,
  triggerElement,
  circleColor,
  circleIcon,
  onClick,
  zIndex,
  offset,
  side,
}) => {
  const element = document.getElementById(`${triggerElement}-${side}`);
  if (!element || hidden) {
    return null;
  }
  return createPortal(
    <CircleButton
      id={id}
      circleColor={circleColor}
      circleIcon={circleIcon}
      onClick={onClick}
      zIndex={zIndex}
      offset={offset}
    />,
    element
  );
};
